// 登录页
import { useEffect, useState } from 'react';
import styles from './index.module.less';
import cs from 'classnames';
import { Form, Tabs } from 'antd';
import { isMobile, urlParams } from '@lhb/func';
import CodeLogin from './components/CodeLogin';
import AccountLogin from './components/AccountLogin';
import ChangeAccount from './components/ChangeAccount';
import ModalHint from '@/common/components/business/ModalHint';
import { MOBILE_REG } from '@lhb/regexp';
import CompleteInfo from '../CompleteInfo';
import { useMethods } from '@lhb/hook';
import { getShareContent } from '@/common/api/common';

const Login = () => {
  const [accountForm] = Form.useForm();
  const [codeForm] = Form.useForm();
  const [showAccountModal, setShowAccountModal] = useState<boolean>(false);
  const [modalVisible, setModalVisible] = useState<boolean>(false); // 试用用户到期时联系客服提示框
  const [imgLoad, setImgLoad] = useState<boolean>(false);
  const [infoData, setInfoData] = useState<any>({
    visible: false,
    mobile: undefined
  });
  // 分享配置
  const shareId = urlParams(location.search)?.shareId; // 分享id
  const [isAutoRegister, setIsAutoRegister] = useState<any>({ // 是否是分享场景：登录即注册
    isLoginAutoRegister: false,
    tenantId: null,
  });
  const [isShareConfigToLogin, setIsShareConfigToLogin] = useState<any>(null);
  // 是否是官网跳转过来的
  const isPortal = urlParams(location.search)?.isPortal;

  useEffect(() => {
    shareId && methods.getShareInfo();
  }, [shareId]);

  // 移动端或者扫码打开分享链接时
  useEffect(() => {
    isAutoRegister?.isLoginAutoRegister && isAutoRegister.tenantId && isMobile() && methods.handleJumpMobile();
  }, [isAutoRegister]);

  const imgOnload = () => {
    setImgLoad(true);
  };
  const onChange = (v) => {
    if (v === 'accountLogin') { // 跳转到密码登录
      const value = codeForm.getFieldValue('mobile');
      if (value) {
        accountForm.setFieldValue('username', value);
        accountForm.validateFields(['username']);
      }
    } else { // 跳转到验证码登录
      let value = accountForm.getFieldValue('username');
      if (value) {
        value = value.split('@')[0];
        if (MOBILE_REG.test(value)) {
          codeForm.setFieldValue('mobile', value);
          codeForm.validateFields(['mobile']);
        }
      }
    }
  };

  const methods = useMethods({
    getShareInfo: () => {
      const params = {
        id: shareId
      };
      getShareContent(params).then((res: any) => {
        const { content } = res || {};
        const targetContent = JSON.parse(content);
        const { isLoginAutoRegister, tenantId } = targetContent || {};
        setIsAutoRegister({
          isLoginAutoRegister,
          tenantId
        });
      });
    },
    handleJumpMobile: () => {
      const targetUrl = `${process.env.INSIGHT_URL}/login?shareId=${shareId}`;
      window.location.replace(targetUrl || '/');
    },
  });
  return (
    <>
      <div className={cs(styles.container, isMobile() && styles.mobileContainer)}>
        <div className={styles.fixShadowWhiteLine}>
          <div className={cs(styles.content, imgLoad && styles.show)}>
            { !isMobile() && <img src='https://staticres.linhuiba.com/project-custom/locationpc/console-pc-login.png?t=2023052502' alt='' onLoad={imgOnload}/> }
            <div className={styles.wrapper}>
              <div className={styles.rightWrapper}>
                <div className={styles.right}>
                  <p className={styles.title}>欢迎登录</p>
                  <Tabs
                    defaultActiveKey='codeLogin'
                    size='large'
                    tabBarGutter={48}
                    onChange={onChange}
                    items={[
                      { label: '验证码登录', key: 'codeLogin', children: <CodeLogin
                        setShowAccountModal={setShowAccountModal}
                        setModalVisible={setModalVisible}
                        form={codeForm}
                        isAutoRegister={isAutoRegister}
                        setInfoData={setInfoData}
                        setIsShareConfigToLogin={setIsShareConfigToLogin}
                      /> },
                      { label: '密码登录', key: 'accountLogin', children: <AccountLogin setShowAccountModal={setShowAccountModal}
                        setModalVisible={setModalVisible}
                        form={accountForm}
                        isAutoRegister={isAutoRegister}
                        setInfoData={setInfoData}
                        setIsShareConfigToLogin={setIsShareConfigToLogin}
                      /> }
                    ]} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ChangeAccount
        showAccountModal={showAccountModal}
        setShowAccountModal={setShowAccountModal}
        isShareConfigToLogin={isShareConfigToLogin}
      />
      {/* 0815 取消了注册试用账号的逻辑 该段逻辑废弃了 */}
      {
        infoData.visible && <CompleteInfo infoData={infoData} isPortal={+isPortal === 1}/>
      }

      <ModalHint
        visible={modalVisible}
        setVisible={setModalVisible}
        content='用户已到期，如需继续试用或者了解更多详情请联系客服'/>
    </>
  );
};

export default Login;
